import { default as indexelPorSShqQMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/about-us/index.vue?macro=true";
import { default as indexZGBNEqISccMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/create/index.vue?macro=true";
import { default as indextxAUK1PtHxMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/FAQ/index.vue?macro=true";
import { default as index4lLbh0CpbpMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/fresh/index.vue?macro=true";
import { default as indexWSSNt0CdDQMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/index.vue?macro=true";
import { default as indexhHdqDRIvlNMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/login/index.vue?macro=true";
import { default as _91id_93ePK8u8P4QrMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/payment/pay/[id].vue?macro=true";
import { default as indexa6CcW9tt2wMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/payment/success/index.vue?macro=true";
import { default as indexme8zeUcZ4pMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/index.vue?macro=true";
import { default as index9TWhSao2NUMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/recipes/index.vue?macro=true";
import { default as index2BvVLnpQByMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/vets/index.vue?macro=true";
export default [
  {
    name: "about-us___es",
    path: "/about-us",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/about-us/index.vue")
  },
  {
    name: "create___es",
    path: "/create",
    meta: indexZGBNEqISccMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/create/index.vue")
  },
  {
    name: "FAQ___es",
    path: "/FAQ",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/FAQ/index.vue")
  },
  {
    name: "fresh___es",
    path: "/fresh",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/fresh/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/index.vue")
  },
  {
    name: "login___es",
    path: "/login",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/login/index.vue")
  },
  {
    name: "payment-pay-id___es",
    path: "/payment/pay/:id()",
    meta: _91id_93ePK8u8P4QrMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/payment/pay/[id].vue")
  },
  {
    name: "payment-success___es",
    path: "/payment/success",
    meta: indexa6CcW9tt2wMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/payment/success/index.vue")
  },
  {
    name: "profile___es",
    path: "/profile",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/index.vue")
  },
  {
    name: "recipes___es",
    path: "/recipes",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/recipes/index.vue")
  },
  {
    name: "vets___es",
    path: "/vets",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/vets/index.vue")
  }
]